export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [
      { method: 'GET', path: '/internalcontrol/purchase_batch' },
      { method: 'POST', path: '/internalcontrol/purchase_batch/switch/{id}' },
      { method: 'GET', path: '/ucenter/org/all' },
      { method: 'GET', path: '/ucenter/user' },
      { method: 'GET', path: '/internalcontrol/purchase_batch/detail' },
      { method: 'GET', path: '/internalcontrol/purchase_batch/detail/by_auth' },
      { method: 'POST', path: '/internalcontrol/purchase_batch/detail' },
      { method: 'PUT', path: '/internalcontrol/purchase_batch/detail/{id}' },
      { method: 'DELETE', path: '/internalcontrol/purchase_batch/detail/{id}' },
      { method: 'POST', path: '/internalcontrol/purchase_batch/detail/switch/{id}' },
      { method: 'GET', path: '/internalcontrol/budget/detail' },
      { method: 'GET', path: '/internalcontrol/assets_type/tree' },
      { method: 'GET', path: '/internalcontrol/goods' },
      { method: 'POST', path: '/internalcontrol/goods' },
      { method: 'PUT', path: '/internalcontrol/goods/{id}' },
      { method: 'GET', path: '/internalcontrol/status_manage/switch_config' },
      { method: 'GET', path: '/internalcontrol/status_manage/config' }
    ]
  },
  manage: {
    funKey: 'manage',
    name: '管理',
    apis: [
      { method: 'POST', path: '/internalcontrol/purchase_batch' },
      { method: 'PUT', path: '/internalcontrol/purchase_batch/{id}' },
      { method: 'DELETE', path: '/internalcontrol/purchase_batch/{id}' }
    ]
  },
  viewFile: {
    funKey: 'viewFile',
    name: '查看会议材料',
    apis: [
      { method: 'GET', path: '/fms/file' },
      { method: 'GET', path: '/fms/download' }
    ]
  },
  upload: {
    funKey: 'upload',
    name: '上传会议材料',
    apis: [
      { method: 'PUT', path: '/internalcontrol/purchase_batch/file_ids/{id}' },
      { method: 'POST', path: '/fms/upload' }
    ]
  },
  delFile: {
    funKey: 'delFile',
    name: '删除会议材料',
    apis: [
      { method: 'PUT', path: '/internalcontrol/purchase_batch/file_ids/{id}' },
      { method: 'DELETE', path: '/fms/file' }
    ]
  }
}